/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @file Column component for displaying a profile picture
 * @author Heino Lenting

 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".sym-column-editor-profile-picture .sym-profile-picture{margin-top:6px;margin-left:1px}"];
export { styles as styles };
